import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyMaterialModule } from './my-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularFireAuthGuard } from '@angular/fire/auth-guard';
import { HomeComponent } from './home/home.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CargaArchivosComponent } from './carga-archivos/carga-archivos.component';
import { ErroresArchivoComponent } from './errores-archivo/errores-archivo.component';
import { VendedoresComponent } from './vendedores/vendedores.component';
import { SimcardsComponent } from './simcards/simcards.component';
import { ReferidosComponent } from './referidos/referidos.component';
import { PuntosVentaComponent } from './puntos-venta/puntos-venta.component';
import { DocPipe } from './doc.pipe';
import { SumPipe } from './sum.pipe';
import { TropasComponent } from './tropas/tropas.component';
import { VentasTropasComponent } from './ventas-tropas/ventas-tropas.component';
import { PagosComponent } from './pagos/pagos.component';
import { PortabilidadesComponent } from './portabilidades/portabilidades.component';
import { VentasFijasComponent } from './ventas-fijas/ventas-fijas.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ValidacionesComponent } from './validaciones/validaciones.component';
import { SolicitudesNipComponent } from './solicitudes-nip/solicitudes-nip.component';

@NgModule({
  declarations: [
    AppComponent,    
    DocPipe, SumPipe,
    LoginComponent,
    HomeComponent,
    UsuariosComponent,
    VendedoresComponent,
    SimcardsComponent,
    ReferidosComponent,
    PuntosVentaComponent,    
    TropasComponent,
    CargaArchivosComponent,    
    VentasTropasComponent,
    PagosComponent,
    PortabilidadesComponent,
    VentasFijasComponent,
    ValidacionesComponent,
    SolicitudesNipComponent,
    ErroresArchivoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MyMaterialModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, 
    AngularFireAuthModule, 
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    AngularFireMessagingModule,
    FormsModule, ReactiveFormsModule,
    FlexLayoutModule,
    MatTableExporterModule
  ],
  providers: [    
    AngularFireAuthGuard,
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
